// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Reasons for inventory adjustments.
 */
export const ADJUSTMENT_REASONS = [
  { value: 'damage', label: 'Damage/Defective' },
  { value: 'loss', label: 'Loss/Missing' },
  { value: 'correction', label: 'Count Correction' },
  { value: 'return', label: 'Return to Stock' },
  { value: 'other', label: 'Other' },
];
